import React, { Component } from "react";
import { connect } from "react-redux";
import "./index.css";
import SignInContainer from "../../components/containers/SignInContainer";
import { Row, Col, Card, Input, Button } from "antd";
import { AuthAction } from "../../store/actions";
import { FaUserCircle } from "react-icons/fa";
import BlackImage from "../../assets/images/black.jpg";
import CustomModal from "../../components/modals/customModal";
import Profile_success from "../../assets/images/profile_success.png";
import UserIcon from "../../assets/images/User.png";
import UserIconOver from "../../assets/images/UserOver.png";
class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      emailError: "",
      passwordError: "",
      isOpen: false,
    };
  }

  onHandleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      [`${e.target.name}Error`]: "",
      errorReducer: "",
    });
  };
  onSubmit = () => {
    const { email } = this.state;

    if (!email.length) {
      if (!email.length) {
        this.setState({
          emailError: "Email required",
        });
      }
      return;
    }
    this.props.ResetPassword({ email }, () =>
      this.setState({
        isOpen: true,
      })
    );
  };
  componentDidUpdate(preProps, PreState) {
    if (preProps.error !== this.props.error && !this.props.loader) {
      this.setState({
        errorReducer: "Oops, thats not a match",
      });
    }
  }

  render() {
    const { signin, loader, error } = this.props;
    const { emailError, isOpen } = this.state;
    return (
      <SignInContainer>
        <Row justify="center">
          <Col xs={22} sm={18} md={12} lg={11} xl={24}>
            <Row justify="center" gutter={[0, 40]} align="middle">
              <Col span={24} style={{ marginTop: "5rem" }}>
                <Card style={{ width: "100%" }}>
                  <Row gutter={[0, 15]} style={{ position: "relative" }}>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      style={{
                        height: "155px",
                        borderRadius: "50%",
                        backgroundSize: "cover",
                        // backgroundPosition: "center center",
                        backgroundImage: `url(${BlackImage})`,
                        position: "absolute",
                        border: "5px solid #fff",
                        top: "-90px",
                        right: 0,
                        left: "25%",
                      }}
                    >
                      {/* <img src={coverProfile} style={{ objectFit: "cover", borderRadius: "50%" }} height={"160px"} width={"100%"} /> */}
                    </Col>
                    <Col span={24} style={{ marginTop: "120px" }}>
                      <Row gutter={[0, 15]} justify="center">
                        <Col span={20}>
                          <Input
                            style={{
                              borderBottom: "1px solid gray",
                              padding: "10px",
                            }}
                            bordered={false}
                            size="25"
                            placeholder="USERNAME"
                            name="email"
                            onMouseOver={(e) => {
                              // console.log('hello world',e.target.name)
                              this.setState({
                                [`${e.target.name}_onHover`]: true,
                              });
                            }}
                            onMouseOut={(e) => {
                              // console.log('hello world',e.target.name)
                              this.setState({
                                [`${e.target.name}_onHover`]: false,
                              });
                            }}
                            onChange={this.onHandleChange}
                            prefix={
                              <img
                                src={
                                  !this.state["email_onHover"] ?
                                    UserIcon
                                    :
                                    UserIconOver
                                } />
                            }
                          />

                          <Row>
                            <Col span={24}>
                              <span className="text-right d-grid danger-color">
                                {emailError && emailError}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      <Col style={{ marginTop: "20px" }}>
                        <Button
                          style={{
                            backgroundColor: "#ff9800",
                            color: "#fff",
                            width: "50%",
                          }}
                          onClick={this.onSubmit}
                        >
                          Reset
                        </Button>
                      </Col>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>

        <CustomModal
          visible={isOpen}
          onCancelModal={() =>
            this.setState({
              isOpen: false,
            })
          }
          footer={[
            <Row justify="center" style={{ margin: "20px" }}>
              <Col
                className="d-flex justify-content-center"
                style={{ width: "100%" }}
              >
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => this.setState({ isOpen: false })}
                >
                  Ok
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col className="d-flex justify-content-center" span={24}>
              <img src={Profile_success} />
            </Col>
            <Col span={18} style={{ textAlign: "center" }}>
              <span>
                An email with instructions has been sent to your inbox
              </span>
            </Col>
          </Row>
        </CustomModal>
      </SignInContainer>
    );
  }
}

function mapStateToProps(storeState) {
  return {
    loader: storeState?.AuthReducer.loader,
    error: storeState?.AuthReducer.error,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ResetPassword: (payload, cb, callback) => {
      dispatch(AuthAction.ResetPassword(payload, cb));
    },

    socialSignIn: (payload, cb) => {
      dispatch(AuthAction.SocialSignInReq(payload, cb));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
